import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { UserStatistics } from '@pixacare/domain';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Cacheable } from 'ts-cacheable';

@Injectable({
  providedIn: 'root',
})
export class StatisticsHttpService {
  private readonly http = inject(HttpClient);

  @Cacheable({ maxAge: 1 * 60 * 1000 }) // 5 minutes
  getUserStatistics(): Observable<UserStatistics> {
    return this.http.get<UserStatistics>(`${environment.apiBaseUrl}/Statistics`);
  }
}
